/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */

import React from 'react';
import Icon from '@atlaskit/icon';
import type { CustomGlyphProps, IconProps } from '@atlaskit/icon/types';

const JSMLifeSaverGlyph = (props: CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 40 40"
		data-testid={props['data-testid']}
		aria-label={props['aria-label']}
		// eslint-disable-next-line jira/react/no-classname-attribute, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={props.className}
	>
		<g clip-path="url(#clip0_5852_7911)">
			<path
				d="M11.9885 17.3889V17.5556C12.3936 16.1725 13.1356 14.9116 14.1478 13.8857C15.1601 12.8599 16.411 12.1013 17.7885 11.6778H17.7219V2.13333C13.8757 2.69528 10.3135 4.48345 7.56497 7.232C4.81643 9.98054 3.02826 13.5427 2.46631 17.3889H11.9885Z"
				fill="currentColor"
			/>
			<path
				d="M22.9443 11.7C24.2796 12.1219 25.4937 12.8592 26.4839 13.8494C27.4741 14.8396 28.2113 16.0536 28.6332 17.3889H38.1999C37.6379 13.5427 35.8498 9.98054 33.1012 7.232C30.3527 4.48345 26.7905 2.69528 22.9443 2.13333V11.7Z"
				fill="currentColor"
			/>
			<path
				d="M28.6332 22.6111C28.2121 23.9468 27.4752 25.1613 26.4849 26.1516C25.4946 27.142 24.2801 27.8789 22.9443 28.3V37.8667C26.7905 37.3047 30.3527 35.5165 33.1012 32.768C35.8498 30.0195 37.6379 26.4573 38.1999 22.6111H28.6332Z"
				fill="currentColor"
			/>
			<path
				d="M17.7219 28.3C16.3746 27.8756 15.1508 27.1299 14.1558 26.1272C13.1609 25.1245 12.4247 23.895 12.0108 22.5444V22.6222H2.46631C3.03046 26.4664 4.8196 30.0261 7.56796 32.7724C10.3163 35.5188 13.8773 37.3053 17.7219 37.8667V28.3Z"
				fill="currentColor"
			/>
			<g opacity="0.5">
				<path
					opacity="0.5"
					d="M11.6441 20C11.6467 19.1761 11.7664 18.3568 11.9997 17.5667V17.4H2.55523C1.96586 17.4 1.40063 17.6341 0.983882 18.0509C0.567134 18.4676 0.333008 19.0329 0.333008 19.6222L0.333008 20.4C0.333008 20.9894 0.567134 21.5546 0.983882 21.9714C1.40063 22.3881 1.96586 22.6222 2.55523 22.6222H12.0219V22.5445C11.7704 21.7197 11.6431 20.8622 11.6441 20Z"
					fill="currentColor"
				/>
				<path
					opacity="0.5"
					d="M20.3328 11.3C21.2185 11.2995 22.099 11.4344 22.9439 11.7V2.22222C22.9439 1.63285 22.7098 1.06762 22.293 0.650874C21.8763 0.234126 21.3111 0 20.7217 0L19.9439 0C19.3545 0 18.7893 0.234126 18.3726 0.650874C17.9558 1.06762 17.7217 1.63285 17.7217 2.22222V11.6889H17.7883C18.6125 11.4337 19.47 11.3026 20.3328 11.3Z"
					fill="currentColor"
				/>
				<path
					opacity="0.5"
					d="M28.6328 17.3889C29.1662 19.0888 29.1662 20.9112 28.6328 22.6111H38.1106C38.7 22.6111 39.2652 22.377 39.6819 21.9602C40.0987 21.5435 40.3328 20.9783 40.3328 20.3889V19.6111C40.3328 19.0217 40.0987 18.4565 39.6819 18.0398C39.2652 17.623 38.7 17.3889 38.1106 17.3889H28.6328Z"
					fill="currentColor"
				/>
				<path
					opacity="0.5"
					d="M20.3328 28.7C19.4471 28.7005 18.5666 28.5656 17.7217 28.3V37.7778C17.7217 38.3671 17.9558 38.9324 18.3726 39.3491C18.7893 39.7659 19.3545 40 19.9439 40H20.7217C21.3111 40 21.8763 39.7659 22.293 39.3491C22.7098 38.9324 22.9439 38.3671 22.9439 37.7778V28.3C22.099 28.5656 21.2185 28.7005 20.3328 28.7Z"
					fill="currentColor"
				/>
			</g>
		</g>
		<defs>
			<clipPath id="clip0_5852_7911">
				<rect width="48" height="48" fill="white" transform="translate(0.333008)" />
			</clipPath>
		</defs>
	</svg>
);

const JSMLifeSaverIcon = (props: IconProps) => <Icon {...props} glyph={JSMLifeSaverGlyph} />;

export default JSMLifeSaverIcon;
